// @ts-check
/// <reference path="./typedefs.js" />
import isEmpty from 'lodash.isempty';

/**
 * Возвращает отформатированный объект пользователя
 * @param data
 * @param canFullEdit
 * @return {UserSessionResponse}
 */
export const convertUserSessionResponse = (data = {}, canFullEdit = false) => {
  let firstName = null;
  if (!isEmpty(data.firstName)) {
    firstName = data.firstName.trim();
  }

  let lastName = null;
  if (!isEmpty(data.lastName)) {
    lastName = data.lastName.trim();
  }

  let secondName = null;
  if (!isEmpty(data.secondName)) {
    secondName = data.secondName.trim();
  }

  const firstNameArr = (typeof firstName !== 'string' ? '' : firstName).split(' ');
  if (firstNameArr.length > 1 && !lastName) {
    firstName = firstNameArr[0];
    lastName = firstNameArr[1];
  }

  const name = [lastName, firstName, secondName].filter(part => part).join(' ');
  return {
    name,
    firstName,
    lastName,
    secondName,
    email: data?.email || null,
    phone: data?.personalPhone || null,
    phoneMobile: data?.personalMobile || null,
    inn: data?.ufInn || null,
    organizationName: data?.ufNaz || null,
    legalAddress: data?.ufUrAddress || null,
    kpp: data?.ufKpp || null,
    bik: data?.ufBik || null,
    correspondentAccount: data?.ufKor || null,
    checkingAccount: data?.ufCheckingAccount || null,
    bankName: data?.ufNaim || null,
    canFullEdit: canFullEdit ? 'Y' : 'N',
  };
};

/**
 * Возвращает отформатированный объект данных юзера для запроса к API
 * @param {PrepareUserData} payload
 * @return {PrepareUserDataResult}
 */
export const prepareUserData = (payload) => {
  const isEntity = payload.personType === 2;
  const personType = payload.personType || 1;
  const authorize = payload.authorize || 'Y';
  const unsubscribed = payload.unsubscribed || 0;
  const book24OrderRegister = payload.book24OrderRegister || 'Y';

  const postData = {
    ID: payload.userId,
    EMAIL: payload.email,
    LAST_NAME: payload.lastName,
    NAME: payload.name,
    SECOND_NAME: payload.secondName,
    PERSONAL_PHONE: payload.phone,
    PERSONAL_MOBILE: payload.phoneMobile,
    AUTHORIZE: authorize,
    PERSON_TYPE_ID: personType,
    UF_CRMC_UNSUBSCRIBED: unsubscribed,
    BOOK24_ORDER_REGISTER: book24OrderRegister,
    captchaToken: payload.captchaToken,
    captchaAction: payload.captchaAction,
    captchaVersion: payload.captchaVersion,
  };

  if (Array.isArray(payload.children) && payload.children.length) {
    Object.assign(postData, { CHILDREN: payload.children });
  }

  if (payload.userId) {
    Object.assign(postData, { ID: payload.userId });
  }

  if (payload.mnogoRuCard) {
    Object.assign(postData, { MNOGORU_CARD: payload.mnogoRuCard });
  }

  if (payload.gender) {
    Object.assign(postData, { PERSONAL_GENDER: payload.gender });
  }

  if (payload.birthday) {
    Object.assign(postData, { PERSONAL_BIRTHDAY: payload.birthday });
  }

  if (isEntity) {
    Object.assign(postData, {
      UF_INN: payload.inn,
      UF_NAZ: payload.organizationName,
      UF_UR_ADDRESS: payload.legalAddress,
      UF_KPP: payload.kpp,
      UF_BIK: payload.bik,
      UF_KOR: payload.correspondentAccount,
      UF_CHECKING_ACCOUNT: payload.checkingAccount,
      UF_NAIM: payload.bankName,
    });
  }

  return postData;
};
